export function getdata() {
	let obj = {
		searchlist: [{
			prop: "test7",
			label: '开票日期起',
			type: "realdate"
		}, {
			prop: "test7",
			label: '开票日期止',
			type: "realdate"
		}, {
			prop: "test1",
			label: '对方纳税人名称',
			type: "input"
		}, ],
		headData: [{
			title: '对方纳税人名称',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '纳税人识别号',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '数电票号码',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '价税合计',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '对应蓝票数票号码',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '未税金额',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '发票税额',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '开票日期',
			prop: 'tes3',
			width: '150',
			issort: true
		}, {
			title: '操作',
			prop: 'cz',
			width: '150',
			custom: true,
			fixed: 'right',
		}],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 3,
			paginationkey: 0
		},
	}
	return obj
}
